import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { CalendarEventItem } from 'src/app/models/ExamsAndTasksCalendar/calendarEventItem';
import { ExamAndTaskCalenderItem } from 'src/app/models/ExamsAndTasksCalendar/examAndTaskCalenderItem';
import { StudentDataType } from 'src/app/models/enums/StudentDataType';
import { FiltersColorHelper } from 'src/app/utils/helpers/filtersColorHelper';

@Component({
  selector: 'app-exam-item',
  templateUrl: './exam-item.component.html',
  styleUrls: ['./exam-item.component.scss', './exam-item.component.en.scss']
})
export class ExamItemComponent {
  @Input() data!: ExamAndTaskCalenderItem;
  @Input({ required: true }) studentCalendarFilters: any;
  @Input() notificationsHeaderText: string = "";
  currentEvent!: CalendarEventItem | null;
  openedMainNotifications: boolean = false;

  @Output() openPopup: EventEmitter<void> = new EventEmitter<void>();

  @HostBinding('style.--type-color') get type() {
    return FiltersColorHelper.getPrimaryColor(this.data.calenderDataType as number, this.studentCalendarFilters);
  };

  @HostBinding('style.--type-color-rgb') get typeRgb() {
    return FiltersColorHelper.getSecondaryColor(this.data.calenderDataType as number, this.studentCalendarFilters);
  };

  @HostBinding('class.academic-event') get academicEvent(): boolean {
    return this.data.calenderDataType === StudentDataType.Event ? true : false;
  };

  isTimeEmpty(dateTime: string): boolean {
    return dateTime.endsWith('T00:00:00Z');
  }

  openEventPopup() {
    this.openPopup.emit();
    setTimeout(() => {
      this.currentEvent = {
        start: new Date(this.data.date),
        title: this.data.courseName ? this.data.courseName : this.data.name,
        allDay: true,
        eventData: this.data
      };
    }, 50);
  }

  closeEventPopup() {
    this.currentEvent = null;
  }
  
  getPopupColor() {
    let color = this.type;
    return color ? color : FiltersColorHelper.defaultColor;
  }

  openNotificationFromMain(event: any) {
    event.preventDefault();
    this.openedMainNotifications = true;
  }

  closeMainNotifications() {
    this.openedMainNotifications = false;
  }
}
